import useDomainFilePick from "@/customhooks/useDomainFilePick";
import { EventNames } from "@/utils/events";
import { TriggerCallRedirectEvent } from "@/utils/events/events.helpers";
import { ROOM_TYPE } from "@/types/common.types";
import React from "react";
import styles from "./AstroLiveCard.module.scss";

interface AstroHeaderProps {
  title: string;
  subTitle?: string;
  type: ROOM_TYPE;
}

const AstroHeader = ({ title, subTitle, type }: AstroHeaderProps) => {
  const { hostname } = useDomainFilePick();
  const onViewAllClick = () => {
    let baseUrl = "https://chingari.io";
    if (hostname === "astrolive") {
      baseUrl = baseUrl.replace("chingari.io", "astrolive.app");
    }
    TriggerCallRedirectEvent(EventNames.DeepLink, {
      page: `${baseUrl}/${
        type === ROOM_TYPE.LIVE ? "live" : "calls"
      }?page=astrology&category=all`,
    });
  };

  return (
    <div className={styles.headerWrapper}>
      <div className={styles.header}>
        <h3>{title}</h3>
        <p>{subTitle}</p>
      </div>
      <span onClick={onViewAllClick}>{"View all >"}</span>
    </div>
  );
};

export default AstroHeader;
